import { useAnalytics } from '../../hooks/useAnalytics';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  // Initialize analytics inside Router context
  useAnalytics();

  return <>{children}</>;
};

export default AnalyticsProvider;
